/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

export * from "./CosmosPageLegalContent.client";
export * from "./CosmosPageLegalContent.data";
export * from "./CosmosPageLegalContent.page";
